import type { DeletePromptModalProps } from "../types";

import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";

export const DeletePromptModal: React.FC<DeletePromptModalProps> = ({
  isOpen,
  prompt,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const handleConfirm = async () => {
    if (prompt) {
      await onConfirm(prompt.id);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>{t("Confirm Delete")}</ModalHeader>
        <ModalBody>
          {t("Are you sure you want to delete the prompt")} "{prompt?.name}"?
        </ModalBody>
        <ModalFooter>
          <Button onPress={onClose}>{t("Cancel")}</Button>
          <Button color="danger" onPress={handleConfirm}>
            {t("Delete")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
